import AssetsInstallationDetailGeneralInfo from "./AssetsInstallationDetailGeneralInfo";
export default AssetsInstallationDetailGeneralInfo;
